import { mountVueComponent } from '@/lib/mount-vue-component';
import store from '@/lib/store';
import UserList from './components/UserList';
import Vue from 'vue';

export default function () {
	import('@/lib/components/User/ProfilePhoto.vue').then((profilePhoto) => {
		mountVueComponent('profile-photo', profilePhoto);
	});

	const userList = new Vue({
		el: '#user-list',
		name: 'UserListApp',
		components: {
			UserList,
		},
		store,
	});

	$(document).one('pjax:end', () => {
		userList.$destroy();
	});
}
